import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { style: {"color":"#737373","font-weight":"500","font-size":"13px","position":"absolute","left":"185px","top":"36%"} }

import { ref, watch, onMounted } from "vue";
import { PhArrowRight } from "@phosphor-icons/vue";
import { LottieAnimation } from "lottie-web-vue";
import { useRoute } from "vue-router";

import CircularDots from "@/assets/CircularDots.json";
// import DynamicGradient from "@/assets/DynamicGradient.json";
import { navigateToRestricted } from "@/router";


export default /*@__PURE__*/_defineComponent({
  __name: 'OptimizeSignalAudioAndImpedancePanelImpedancePanel',
  props: {
    isImpedanceCheckRunning: { type: Boolean },
    impedanceCheckChannel: {},
    runImpedanceCheck: { type: Function },
    nextRoute: {},
    description: {},
    stopRecording: { type: Function }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

// ---- STATE ----

let anim = ref();
// let animBackground = ref();

const route = useRoute();

const isImpedanceCheckFinished = ref(false);

const progressValue = ref(0);
const bufferValue = ref(20);
const interval = ref(0);

// ---- CALLBACKS ----

const handleContinue = async () =>
  await props.stopRecording().then(async () => {
    emit("close");

    console.log(
      "stopped recording, navigating to next route " + props.nextRoute,
    );

    navigateToRestricted(props.nextRoute, route.query);
  });

const startBuffer = () => {
  clearInterval(interval.value);

  // Reset progress values
  progressValue.value = 0;
  bufferValue.value = 0;

  // Calculate the total time and interval duration
  const totalTime = 6000; // 5 seconds in milliseconds
  const steps = 100; // Number of steps to complete progress
  const intervalDuration = totalTime / steps;

  // Start the interval to update progress
  interval.value = setInterval(() => {
    // Increment progress values
    progressValue.value += 100 / steps;
    bufferValue.value += 100 / steps;

    // Check if progress has reached 100%
    if (progressValue.value >= 100) {
      // Ensure the progress bar is exactly at 100%
      progressValue.value = 100;
      bufferValue.value = 100;
      // Stop the interval after the delay
      clearInterval(interval.value);
    }
  }, intervalDuration);
};

// ---- LIFECYCLE HOOKS ----

watch(
  () => props.isImpedanceCheckRunning,
  (newValue) => {
    if (newValue) {
      startBuffer();
    }
  },
);

onMounted(async () => {
  await props
    .runImpedanceCheck()
    .then(() => (isImpedanceCheckFinished.value = true));
});

return (_ctx: any,_cache: any) => {
  const _component_VCol = _resolveComponent("VCol")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_VBtn = _resolveComponent("VBtn")!
  const _component_VRow = _resolveComponent("VRow")!

  return (_openBlock(), _createBlock(_component_VCol, {
    class: "flex-grow-1 d-flex h-100 pt-12",
    style: {"position":"absolute","top":"0","left":"0","bottom":"0","width":"100%","height":"100%","overflow":"hidden","z-index":"1000"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_VCol, { class: "flex-grow-1 justify-space-between align-center" }, {
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createElementVNode("h1", {
            class: "mb-3",
            style: {"font-size":"38px","color":"#1a2b5a"}
          }, " Impedance Measurements ", -1)),
          _createElementVNode("p", {
            class: "mb-2",
            style: {"color":"#737373","text-align":"center","font-weight":"500","font-size":"18px","transition":"margin-bottom 0.5s ease-in-out","width":"500px"},
            innerHTML: 
          props.description ??
          'S Resistance measurements for each electrode.<br />You will be able to start your session after this step.'
        
          }, null, 8, _hoisted_1),
          _createVNode(_component_VCol, {
            style: {"width":"210px","min-height":"210px"},
            class: "mt-4 mb-8 d-flex justify-center align-center rounded-circle overflow-hidden position-relative"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(LottieAnimation), {
                style: {"width":"200px","justify-content":"center","align-items":"center","position":"relative"},
                ref_key: "anim",
                ref: anim,
                "animation-data": _unref(CircularDots),
                loop: true,
                "auto-play": true,
                speed: 1
              }, null, 8, ["animation-data"])
            ]),
            _: 1
          }),
          _createVNode(_component_VRow, {
            class: "ga-5 align-center justify-end position-relative w-100 px-8",
            style: {"min-height":"60px","background":"rgba(255, 255, 255, 0.45)","box-shadow":"0 8px 32px 0 rgba(31, 38, 135, 0.37)","backdrop-filter":"blur(10px)","-webkit-backdrop-filter":"blur(10px)"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_progress_linear, {
                class: "mr-auto position-absolute",
                style: {"width":"150px","height":"5px","left":"25px","top":"50%"},
                modelValue: progressValue.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((progressValue).value = $event)),
                "buffer-value": bufferValue.value,
                rounded: "",
                color: "#000000"
              }, null, 8, ["modelValue", "buffer-value"]),
              _createElementVNode("p", _hoisted_2, _toDisplayString(props.impedanceCheckChannel) + "/8 ", 1),
              _createVNode(_component_VRow, { class: "align-start justify-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_VBtn, {
                    class: "flex-grow-0 flex-shrink-1 d-flex",
                    disabled: !isImpedanceCheckFinished.value,
                    "append-icon": _unref(PhArrowRight),
                    onClick: handleContinue
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("Continue")
                    ])),
                    _: 1
                  }, 8, ["disabled", "append-icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})